export const WORK_ID_JOB_APPLICATION_COOKIE_NAME =
  "workid-job-application-cookie";
